import { StoryblokComponent, storyblokEditable } from "@storyblok/react";

const LandingPageContent = ({ blok }) => (
  <>
    <main {...storyblokEditable(blok)} className="no-demo landing-page">
      {blok.pagecontent
        ? blok.pagecontent.map((blok) => (
            <StoryblokComponent blok={blok} key={blok._uid} />
          ))
        : null}
    </main>
  </>
);

export default LandingPageContent;
